import React from "react";
import { useBreakpoint } from "../../../hooks";
import { sortBy } from "../../../utils/commonFunctions";

import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import TeamCard from "../../../components/cards/teamCard";

const Team = ({ teamMembers, teamIntro, teamAcquaintedFamilyText }) => {
  const breakpoint = useBreakpoint();

  return (
    <>
      <h2 className="heading text-left py-5">Meet the team</h2>
      <div className="divide-y width-divider" />

      {teamIntro && (
        <div
          className="py-3 planet:gvi-light-gray-text text-black-lighter tab-content_html"
          dangerouslySetInnerHTML={{ __html: teamIntro }}
        />
      )}

      {teamAcquaintedFamilyText && (
        <h3
          className="py-3"
          dangerouslySetInnerHTML={{ __html: teamAcquaintedFamilyText }}
        />
      )}

      <div className="grid gap-2 grid-cols-1 md:grid-cols-2 py-2 text-sm pt-5">
        <ConditionalSwiper
          condition={breakpoint === "xs"}
          slidesPerView={1.25}
          spaceBetween={10}
          centeredSlides={false}
          className="h-full w-full"
        >
          {teamMembers
            ?.map((themember) => ({
              ...themember,
              managerRank:
                themember?.teamMembersFields.teamPosition?.toLowerCase() ===
                "program manager"
                  ? -1
                  : 0
            }))
            ?.sort(sortBy("managerRank"))
            ?.map((member, index) => {
              const title = member.title;
              const featuredImage = member.featuredImage?.node?.gatsbyImage;
              const sourceFallbackImage = member.featuredImage?.node?.sourceUrl;
              const memberTitle = member?.teamMembersFields?.teamPosition ?? "";
              const memberVideo = member?.teamMembersFields?.memberVideo ?? "";
              const content = member.content;
              const uri = member.uri;
              const linkedInUri =
                member?.teamMembersFields?.memberLinkedin ?? "";

              return (
                <div
                  key={index}
                  className={`${
                    index < 1 ? "sm:col-span-2" : ""
                  } col-span-1 flex items-top justify-center sm:p-2`}
                >
                  <TeamCard
                    sourceUrl={sourceFallbackImage}
                    title={title}
                    bgImage={featuredImage}
                    memberTitle={memberTitle}
                    content={content}
                    uri={uri}
                    linkedinProfile={linkedInUri}
                    memberVideo={memberVideo}
                    featuredCard={index < 1 ? true : false}
                  />
                </div>
              );
            })}
        </ConditionalSwiper>
      </div>
    </>
  );
};

export default Team;
